<template>
    <div class="maya-app-header" :class="{'opacity': opacity}" :style="boxStyle">
        <div class="header">
            <div class="left" @click="leftClickHandler">
                <van-icon :name="$i18n.locale ==='ar-AE' ? 'arrow' : 'arrow-left'" />
                <span v-if="title" class="title">{{ title }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MayaAppHeader',
        props: {
            title: {
                type: String,
                default: ''
            },
            opacity: {
                type: Boolean,
                default: false
            },
            backgroundColor: {
                type: String,
                default: ''
            }
        },
        computed: {
            boxStyle() {
                return {
                    backgroundColor: this.backgroundColor
                }
            }
        },
        methods: {
            leftClickHandler() {
                this.$nextTick(() => {
                    this.$emit('on-click');
                });
            }
        }
    }
</script>

<style lang="less" scoped>
    .maya-app-header {
        position: relative;
        z-index: 10;
        background-color: #fff;
        &.opacity {
            background: transparent;
            .van-icon-arrow-left {
                color: #fff;
            }
            .title {
                color: #fff;
            }
        }
        .header {                    
            position: relative;
            height: 48px;                        
            .left {                            
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;                
                font-size: 14px;     
                padding-left: 35px;
                padding-right: 10px;           
                .van-icon-arrow-left {
                    font-size: 22px;
                    position: absolute;
                    left: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
                .title {
                    line-height: 49px;
                }
            }            
        }
    }
    html[dir="rtl"] .maya-app-header { 
        .header { 
            .left {                   
                left: unset;
                right: 0;
                padding-left: 10px;
                padding-right: 35px; 
                .van-icon-arrow {
                    font-size: 22px;
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .select-country { 
                right: unset;
                left: 16px;
            }
        }
    }
</style>